module.exports = __webpack_public_path__ + "img/02892126001468.538cb403.png";